// extracted by mini-css-extract-plugin
module.exports = {"transition":"Favorites-module--transition--1iyO8","wrapper":"Favorites-module--wrapper--19QGZ"};